import styled from "styled-components";

export const HeaderMenuGiftIndicatorDefaultBox = styled.div`
    width: 10px;
    height: 10px;
    top: 0px;
    left: initial;
    right: 0px;
    border-radius: 50%;
    background-color: ${props => props.theme.components.header.colors.indicatorBadge.backgroundInGridLayout};
    position: absolute;
`;
